'use strict';

import React, { PropTypes } from 'react';
import ClassNameMixin from '../mixins/ClassNameMixin';
import Icon from '../atoms/Icon';
import GrabbagItem from './GrabbagItem';
import ImagePicker from '../organisms/ImagePicker';
import GrabbagImageStore from '../stores/GrabbagImageStore';
import StampDraftStore from '../stores/StampDraftStore';
import UserStore from '../stores/UserStore';
import createStoreMixin from '../mixins/createStoreMixin';
import GrabbagActionCreators from '../actions/GrabbagActionCreators';
import ImageActionCreators from '../actions/ImageActionCreators';
import ModalActionCreators from '../actions/ModalActionCreators';
import DraftActionCreators from '../actions/DraftActionCreators';
import ModalTypes from '../constants/ModalTypes';
import Button from '../atoms/Button';
import PureRenderMixin from '../mixins/PureRenderMixin';
import firstIfShallowEqual from '../utils/firstIfShallowEqual';
import SidebarActionCreators from '../actions/SidebarActionCreators';
import SidebarTypes from '../constants/SidebarTypes';
import BtnGroup from '../molecules/BtnGroup';
import Loader from '../atoms/Loader';
import keyMirror from 'react/lib/keyMirror';
import SafeLocalStorage from '../utils/SafeLocalStorage';
import TabBar from '../molecules/TabBar';
import TabLink from '../atoms/TabLink';
import uniq from 'lodash/array/uniq';
import pluck from 'lodash/collection/pluck';
import union from 'lodash/array/union';

import './Grabbag.less';

const GrabbagTabs = keyMirror({
  UPLOADED: null,
  SAVED: null
});

const GRABBAG_TAB_KEY = 'grabbag.tab';

var Grabbag = React.createClass({
  mixins: [
    ClassNameMixin,
    PureRenderMixin,
    createStoreMixin(GrabbagImageStore, StampDraftStore, UserStore)
  ],

  propTypes: {
    canAutoSave: PropTypes.bool.isRequired
  },

  className: 'editor-Grabbag',

  getInitialState() {
    const activeTabId = SafeLocalStorage.getItem(GRABBAG_TAB_KEY);
    return {
      activeTabId: GrabbagTabs[activeTabId] || GrabbagTabs.UPLOADED
    };
  },

  getStateFromStores() {
    var uploadedItems = GrabbagImageStore.getUploadedImageItems(),
        savedItems = GrabbagImageStore.getSavedImageItems(),
        stampletItems = GrabbagImageStore.getStampletImageItems();

    return {
      uploadedItems: uploadedItems,
      savedItems: savedItems,
      stampletItems: stampletItems,
      isExpectingSavedItems: GrabbagImageStore.isExpectingPage('saved'),
      isExpectingStampletItems: GrabbagImageStore.isExpectingPage('stamplet'),
      draftCount: UserStore.getMe().draftCount,
      hasUnsavedChanges: StampDraftStore.hasUnsavedChanges(),
      isEmpty: StampDraftStore.isEmpty(),
      usedImageUrls: firstIfShallowEqual(
        this.state && this.state.usedImageUrls,
        uniq(pluck(StampDraftStore.getDraftImages(), 'url')).sort()
      )
    };
  },

  getTabs() {
    return [{
      id: GrabbagTabs.UPLOADED,
      title: 'Uploaded Images'
    }, {
      id: GrabbagTabs.SAVED,
      title: 'Saved Images'
    }];
  },

  getItems(tabId) {
    switch (tabId) {
    case GrabbagTabs.UPLOADED:
      return this.state.uploadedItems;
    case GrabbagTabs.SAVED:
      return union(this.state.savedItems, this.state.stampletItems);
    }
  },

  isExpectingPage(tabId) {
    switch (tabId) {
    case GrabbagTabs.UPLOADED:
      return false;
    case GrabbagTabs.SAVED:
      return this.state.isExpectingSavedItems || this.state.isExpectingStampletItems;
    }
  },

  componentDidMount() {
    DraftActionCreators.requestDraftPage(true);
    this.tabDidActivate(this.state.activeTabId);
  },

  componentDidUpdate(prevProps, prevState) {
    const { activeTabId } = this.state;
    const { activeTabId: prevActiveTabId } = prevState;

    if (activeTabId !== prevActiveTabId) {
      this.tabDidActivate(activeTabId);
    }
  },

  tabDidActivate(activeTabId) {
    if (activeTabId === GrabbagTabs.SAVED) {
      ImageActionCreators.requestGrabbagImagesPage('saved');
      ImageActionCreators.requestGrabbagImagesPage('stamplet');
    }
  },

  render() {
    const { canAutoSave } = this.props;
    const { activeTabId, draftCount, hasUnsavedChanges, isEmpty } = this.state;

    return (
      <div className={this.getClassName()}>
        <div className='editor-Grabbag-topBar'>
          <BtnGroup className='utils--floatRight'>
            {canAutoSave && !isEmpty &&
              <span className='editor-Grabbag-saveLabel'>
                {hasUnsavedChanges ?
                  'Saving...' :
                  'Saved'
                }
              </span>
            }
            <Button size='small'
                    color='gray'
                    onClick={this.handleShowDraftsClick}
                    counter={draftCount > 0 ? draftCount : null}>
              Drafts
            </Button>
            <Button color='gray'
                    size='small'
                    round
                    onClick={this.handleHelpClick}>
              ?
            </Button>
          </BtnGroup>
        </div>

        <TabBar context='Grabbag'>
          {this.getTabs().map(tab =>
            <TabLink key={tab.id}
                     active={tab.id === activeTabId}
                     icon={tab.icon}
                     mode={tab.mode}
                     onClick={() => this.handleTabClick(tab.id)}>
              {tab.title}
            </TabLink>
          )}
        </TabBar>

        {this.renderTab(activeTabId)}
      </div>
    );
  },

  renderTab(tabId) {
    var items = this.getItems(tabId),
        isExpectingPage = this.isExpectingPage(tabId);

    if (items.length === 0) {
      return isExpectingPage ?
        <Loader absoluteCenter /> :
        this.renderEmptyTab(tabId);
    }

    return (
      <div className='editor-Grabbag-collection utils--hideScrollbars'>
        {tabId === GrabbagTabs.SAVED && this.renderStampletButton()}
        {tabId === GrabbagTabs.UPLOADED && this.renderUploadButtonItem()}
        {items.map(item => this.renderItem(item, tabId))}
      </div>
    );
  },

  renderStampletButton() {
    return [
      <div/>,
      <Button color='light'
              onClick={this.handleStampletClick}
              className='editor-Grabbag-stampletLink'>
        Get Stampsy Bookmarklet
      </Button>
    ];
  },

  renderEmptyTab(tabId) {
    switch (tabId) {
    case GrabbagTabs.UPLOADED:
      return (
        <div className='editor-Grabbag-message'>
          <Icon name='set' size='large' mode='stroke' />

          <h4 className='editor-Grabbag-title'>Drag images here</h4>

          <div className='editor-Grabbag-divider'>or</div>

          <div className='Btn Btn--light'>
            Choose Images to Upload
            {this.renderImagePicker()}
          </div>

          <div className='editor-Grabbag-warning'>Uploading images that are at least <b>1024px</b> will work best.</div>
        </div>
      );
    case GrabbagTabs.SAVED:
      return (
        <div className='editor-Grabbag-message'>
          <Icon name='collect' size='large' mode='stroke' />

          <div className='editor-Grabbag-warning'>
            Press <Icon name='collect' mode='stroke' size='xxsmall'/> when viewing images on Stampsy to save them here and use in your own Stamps.
          </div>

          <div className='editor-Grabbag-divider'>or</div>

          {this.renderStampletButton()}

          <div className='editor-Grabbag-warning'>And save any images you find on the web straight to your Stampsy editor.</div>
        </div>
      );
    }
  },

  renderItem(item, tabId) {
    var isUsed = false,
        { image } = item;

    if (image) {
      isUsed = this.state.usedImageUrls.indexOf(image.url) > -1;
    }

    return (
      <GrabbagItem key={item.uuid}
                   item={item}
                   isUsed={isUsed}
                   onDeleteClick={() => this.handleDeleteClick(item, tabId)} />
    );
  },

  renderUploadButtonItem() {
    return (
      <div className='editor-GrabbagItem editor-GrabbagItem--upload'>
        {this.renderImagePicker()}
        <Icon name='plus'
              size='small'
              mode='stroke' />
      </div>
    );
  },

  renderImagePicker() {
    return (
      <ImagePicker className='editor-Grabbag-input'
                   onUploadStart={this.handleUploadStart}
                   onUploadError={this.handleUploadError}
                   onUploadProgress={this.handleUploadProgress}
                   onUploadSuccess={this.handleUploadSuccess}
                   hideProgress
                   multiple />
    );
  },

  handleTabClick(tabId) {
    this.setState({
      activeTabId: tabId
    });

    SafeLocalStorage.setItem(GRABBAG_TAB_KEY, tabId);
  },

  handleShowDraftsClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.DRAFTS);
  },

  handleDeleteClick(item, tabId) {
    switch (tabId) {
    case GrabbagTabs.UPLOADED:
      GrabbagActionCreators.deleteGrabbagItem(item.uuid);
      break;
    case GrabbagTabs.SAVED:
      if (item.image.sourceImage) {
        ImageActionCreators.removeFromGrabbag(item.image.sourceImage);
      } else {
         ImageActionCreators.removeStampletItem(item.uuid);
      }
      break;
    }
  },

  handleHelpClick() {
    ModalActionCreators.showModal(ModalTypes.EDITOR_HELP);
  },

  handleStampletClick() {
    ModalActionCreators.showModal(ModalTypes.STAMPLET);
  },

  handleUploadStart(filePath) {
    GrabbagActionCreators.addGrabbagItem(filePath);
  },

  handleUploadError(filePath) {
    GrabbagActionCreators.deleteGrabbagItem(filePath);
  },

  handleUploadProgress(filePath, progress) {
    GrabbagActionCreators.updateGrabbagItem(filePath, { progress: progress });
  },

  handleUploadSuccess(filePath, image) {
    GrabbagActionCreators.updateGrabbagItem(filePath, {
      progress: 0,
      image: image
    });
  }
});

export default Grabbag;



/** WEBPACK FOOTER **
 ** ./editor/Grabbag.jsx
 **/